module.exports = __webpack_public_path__ + "img/reglamentoadultopoomses.081ae326.png";